import React from 'react';
import classnames from 'classnames';

import Show from 'components/Show';

const Title = ({ value, children, className }) => {
	const cls = classnames(
		'font-semibold text-base text-neutral-700 dark:text-white transition-colors',
		className
	);

	return (
		<div className={cls}>
			<Show if={value}>
				{value}
			</Show>

			<Show if={children}>
				{children}
			</Show>
		</div>
	);
};

const Base = ({ value, children, className }) => {
	const cls = classnames(
		'font-normal text-sm text-neutral-700 dark:text-white transition-colors',
		className
	);

	return (
		<div className={cls}>
			<Show if={value}>
				{value}
			</Show>

			<Show if={children}>
				{children}
			</Show>
		</div>
	);
};

const Small = ({ value, children, className }) => {
	const cls = classnames(
		'font-normal text-sm text-neutral-500 dark:text-neutral-500 transition-colors',
		className
	);

	return (
		<div className={cls}>
			<Show if={value}>
				{value}
			</Show>

			<Show if={children}>
				{children}
			</Show>
		</div>
	);
};

export {
	Title,
	Base,
	Small
};